export default "__VITE_ASSET__DSv953$S__"